import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import Cart from "../Cart";

const ProductItemFooter = props => {
	const classes = useStyles();
	const {
		product,
		handleWatchPromotion,
		updateChangeListProduct,
		products,
		carts
	} = props;

	return (
		<Grid container>
			<Grid
				item
				xs={6}
				classes={{
					root: classes.root
				}}
			>
				{product?.isPromotion && (
					<Grid
						classes={{
							root: classes.btnPromotion
						}}
						onClick={() => {
							handleWatchPromotion(product?.id);
						}}
					>
						<Grid
							classes={{
								root: classes.borderLeft
							}}
						/>
						Xem khuyến mãi
						<Grid
							classes={{
								root: classes.borderRight
							}}
						/>
					</Grid>
				)}
			</Grid>
			<Cart
				product={product}
				updateChangeListProduct={updateChangeListProduct}
				products={products}
				carts={carts}
			/>
		</Grid>
	);
};
export default memo(ProductItemFooter);
